import { styled } from '@linaria/react';
import { breakpoints, space } from '../../theme/tokens';

export const TileArea = styled.div`
  width: 100%;
  box-sizing: border-box;

  @media (min-width: ${breakpoints.desktop}) {
    padding: 0 ${space['space-2000']};
  }
`;
